<template>
  <div class="ma-4">
    <SkeletonLoaderTitleUpdate v-show="showSkeleton" />

    <div class="text-h4 mb-4" v-show="!showSkeleton">Atualizar Ramal - {{ `${tipo} ${numero}` }}</div>

    <AbaRamalPjsip v-if="(tipo === 'PJSIP' || tipo === 'WEBRTC') && canRender" edicao="true" :_id="_id" />
    <AbaRamalVirtual v-else-if="tipo === 'VIRTUAL' && canRender" edicao="true" :_id="_id" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { registerVuexModule } from '@/utils/vuexUtils'
import SkeletonLoaderTitleUpdate from '@/componentes/SkeletonLoaderTitleUpdate'

import AbaRamalPjsip from '../_components/AbaRamalPjsip'
import AbaRamalVirtual from '../_components/AbaRamalVirtual'
import ramaisStore from '../_store'

export default {
  name: 'AtualizarRamais',
  props: {
    _id: String,
  },
  components: { AbaRamalVirtual, AbaRamalPjsip, SkeletonLoaderTitleUpdate },
  data: () => ({
    tipo: '',
    numero: '',
    showSkeleton: false,
    canRender: false,
  }),
  computed: {
    ...mapGetters('atualizarRamalModulePABXStore', ['getRamalSelecionado']),
  },
  async created() {
    this.showSkeleton = true

    registerVuexModule(this.$store, 'atualizarRamalModulePABXStore', ramaisStore)
    await this.selecionarRamal(this._id)
    if(this.getRamalSelecionado.webrtc && this.getRamalSelecionado.webrtc == true){
      this.tipo = "WEBRTC"
    }else{
      this.tipo = this.getRamalSelecionado.tipo
    }
    this.numero = this.getRamalSelecionado.numero

    this.showSkeleton = false
    this.canRender = true
  },
  methods: {
    ...mapActions('atualizarRamalModulePABXStore', ['selecionarRamal']),
  },
}
</script>
